module.exports = __webpack_public_path__ + "img/20170314泉润gaga_06.b1673178.jpg";